export enum ParentGender {
  MALE = "male",
  FEMALE = "female",
  OTHER = "other",
  PREFER_NOT_TO_SAY = "prefer_not_to_say",
  NOT_SPECIFIED = "not_specified",
}

export enum AnnualIncome {
  UNDER_5M = "under_5m",
  M5_10M = "5m_10m",
  OVER_10M = "over_10m",
  PREFER_NOT_TO_SAY = "prefer_not_to_say",
}

export enum HouseholdMember {
  MOTHER = "mother",
  FATHER = "father",
  GRANDMOTHER = "grandmother",
  GRANDFATHER = "grandfather",
}

export enum UserRole {
  MOTHER = "mother",
  FATHER = "father",
  GRANDMOTHER = "grandmother",
  GRANDFATHER = "grandfather",
  OTHER = "other",
}

export enum Glasses {
  NONE = "none",
  GLASSES = "glasses",
}

export enum Hairstyle {
  VERY_SHORT = "very_short",
  SHORT = "short",
  MEDIUM = "medium",
  SLIGHTLY_LONG = "slightly_long",
  LONG = "long",
}

export enum BodyType {
  THIN = "thin",
  SLIGHTLY_THIN = "slightly_thin",
  MEDIUM = "medium",
  SLIGHTLY_CHUBBY = "slightly_chubby",
  CHUBBY = "chubby",
}

export enum FaceShape {
  ROUND = "round",
  OVAL = "oval",
  OBLONG = "oblong",
  SQUARE = "square",
  TRIANGLE = "triangle",
}

export type AccountProfile = {
  id?: number;
  account_uuid?: string;
  birthday: string | null;
  gender: ParentGender | null;
  locale: string;
  // お勤め先
  industry: string | null;
  occupation: string | null;
  job_title: string | null;
  organization: string | null;
  annual_income: AnnualIncome | null;
  // 住所
  region: string | null;
  city: string | null;
  // 自分の役割（mother/father/grandmother/grandfather または自由入力テキスト）
  user_role: string | null;
  // 家族
  household_members: string[] | null;
  boys_count: number | null;
  girls_count: number | null;
  // 容姿
  glasses: Glasses | null;
  hairstyle: Hairstyle | null;
  body_type: BodyType | null;
  face_shape: FaceShape | null;
  self_introduction: string | null;
};

export type AccountState = {
  parentProfile: AccountProfile | null;
};
